import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'

@Component({
    selector: 'app-button',
    templateUrl: 'button.html'
})
export class ButtonComponent implements OnInit, OnChanges {
    @Input() disabled = false
    @Input() loading = false
    @Input() type: 'primary' | 'secondary' | 'base' | 'primary-dark' | 'primary-green' = 'primary'
    @Input() modifierClassNames: string
    @Input() htmlType: 'button' | 'submit' | 'reset' = 'button'
    @Input() onClick: Function
    @Input() onBlur: Function
    classNameSuffix: string

    ngOnInit(): void {
        this.classNameSuffix = this.type     
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.type?.previousValue !== changes?.type?.currentValue) {
            this.type = changes.type.currentValue
            this.classNameSuffix = this.type
        }
    }
}
